import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ConcreteProposalOP, SlotsResponseOP } from '@cemex-core/cmx-api';
import { WaitingListDeliveryTimeFlexibility } from '@ordersnproducts/modules/shared/modules/dco/models/waiting-list-delivery-time-flexibility.model';

import { ActionTypes, Actions } from '../actions/dco.action';
import * as fromDCOScheduleActions from './../actions/dco-schedule.action';

// import {
//   OrderBuilderActions,
//   RESET_BUILDER,
// } from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import { CwcTimeSlot } from './../../models/cwc-time-slot.model';

import { OrderStatusModify } from '../../models/order-status-modify-snapshot.model';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import * as moment from 'moment';

export interface KeyValues {
  [key: string]: any;
}

export interface SpecificationFormValues {
  id: number;
  type?: string;
  values: KeyValues;
  relatedProductId?: number;
}
export interface RecipeFormValues extends SpecificationFormValues {
  order?: number; // Grouping
  first?: boolean; // Grouping
  last?: boolean; // Grouping
  expanded?: boolean; // card attribute
  isReady?: boolean;
  messages?: {
    message: string;
    missingAmount: number;
  }[];
}

export interface Slot {
  formID: number;
  fullVisibilityEnabled: boolean;
  requestDatetime?: moment.Moment;
  // api callback
  loading?: boolean;
  response?: SlotsResponseOP;
  error?: any;
  requestDatetimeIsAvailable?: boolean;
  formSnapshot?: RecipeFormValues;
  // user interactions
  isWaitingList?: boolean;
  waitingListDeliveryTimeFlexibility?: WaitingListDeliveryTimeFlexibility;
  selectedDatetimeSlot?: moment.Moment;
  timeSlots?: CwcTimeSlot[];
  loadingScheduleDays?: boolean;
  scheduleDaysError?: any;
  /**
   * indicates if user accepted the liability check
   */
  liabilityCheck?: boolean;
}

export interface State extends EntityState<Slot> {
  selectedSlot: ConcreteProposalOP;
  modifyStatusOrder: OrderStatusModify;
}

export const adapter: EntityAdapter<Slot> = createEntityAdapter<Slot>({
  selectId: (_slot: Slot) => _slot.formID,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedSlot: undefined,
  modifyStatusOrder: null,
});

export function reducer(
  state = initialState,
  action: Actions | fromDCOScheduleActions.Actions | OrderBuilderActions,
): State {
  // if (action.payload.isAvailable != null) {
  //   return adapter.upsertOne(
  //     {
  //       formId: action.payload.formId,
  //       formIndex: action.payload.formIndex,
  //       requestDatetime: action.payload.moment,
  //       requestDatetimeIsAvailable: action.payload.isAvailable,
  //     },
  //     state,
  //   );
  // }
  switch (action.type) {
    case ActionTypes.DELETE_MODIFY_ORDER_STATUS: {
      return { ...state, modifyStatusOrder: null };
    }
    case ActionTypes.ORDER_MODIFY_HAVE_CHANGES: {
      return { ...state, modifyStatusOrder: { ...state.modifyStatusOrder, haveChanges: action.payload } };
    }
    case ActionTypes.SET_MODIFY_ORDER_STATUS: {
      return { ...state, modifyStatusOrder: action.payload };
    }
    case ActionTypes.SET_REQUEST_DATETIME: {
      return adapter.upsertOne(
        {
          formID: action.payload.formID,
          fullVisibilityEnabled: false,
        },
        state,
      );
    }
    case ActionTypes.FETCH_SLOTS: {
      return adapter.upsertOne(
        {
          formID: action.payload.formID,
          loading: true,
          response: undefined,
          error: undefined,
          fullVisibilityEnabled: false,
        },
        state,
      );
    }
    case ActionTypes.FETCH_SLOTS_SUCCESS: {
      return adapter.updateOne(
        {
          id: action.payload.formID,
          changes: {
            loading: false,
            response: action.payload.response,
            error: undefined,
          },
        },
        state,
      );
    }
    case ActionTypes.FETCH_SLOTS_ERROR: {
      return adapter.updateOne(
        {
          id: action.payload.formID,
          changes: {
            loading: false,
            response: null,
            error: action.payload.error,
          },
        },
        state,
      );
    }
    case ActionTypes.MARK_SLOT_AVAILABLE: {
      return adapter.updateOne(
        {
          id: action.payload.formID,
          changes: {
            requestDatetimeIsAvailable: action.payload.isAvailable,
          },
        },
        state,
      );
    }
    case ActionTypes.CHECK_WAITING_LIST: {
      return adapter.updateOne(
        {
          id: action.payload.formID,
          changes: {
            isWaitingList: action.payload.checked,
          },
        },
        state,
      );
    }
    case ActionTypes.ACCEPT_LIABILITY_CHECK: {
      return adapter.updateOne(
        {
          id: action.payload.formID,
          changes: {
            liabilityCheck: action.payload.checked,
          },
        },
        state,
      );
    }
    case ActionTypes.SELECT_DATETIME_SLOT: {
      return adapter.updateOne(
        {
          id: action.payload.formID,
          changes: {
            selectedDatetimeSlot: action.payload.moment,
          },
        },
        state,
      );
    }
    case ActionTypes.SET_SELECTED_SLOT: {
      return {
        ...state,
        selectedSlot: action.payload,
      };
    }
    case ActionTypes.RESET_SELECTED_SLOT: {
      return {
        ...state,
        selectedSlot: undefined,
      };
    }
    case ActionTypes.ENABLE_FULL_VISIBILITY: {
      return adapter.updateOne(
        {
          id: action.payload.formID,
          changes: {
            fullVisibilityEnabled: action.payload.enable,
          },
        },
        state,
      );
    }
    case ActionTypes.TRIGGER_RESET_WARNING: {
      return adapter.updateOne(
        {
          id: action.payload.formId,
          changes: {},
        },
        state,
      );
    }
    case fromDCOScheduleActions.ActionTypes.PUSH_TIME_SLOTS: {
      let aux: Slot;
      for (const id in state.entities) {
        if (Object.prototype.hasOwnProperty.call(state.entities, id)) {
          const element = state.entities[id];
          if (element.formID === action.payload.formId) {
            aux = element;
          }
        }
      }
      let auxArray = [];
      if (aux.timeSlots != null) {
        auxArray = aux.timeSlots;
      }
      action.payload.timeslots.forEach((payloadItem) => {
        const foundIndex = auxArray.findIndex((auxItem) => auxItem.dateMoment.isSame(payloadItem.dateMoment, 'day'));
        if (foundIndex === -1) {
          auxArray.push(payloadItem);
        }
      });
      auxArray.sort((a, b) => a.dateMoment.diff(b.dateMoment));
      return adapter.updateOne(
        {
          id: action.payload.formId,
          changes: {
            timeSlots: action.payload.timeslots,
            loadingScheduleDays: false,
          },
        },
        state,
      );
    }
    case fromDCOScheduleActions.ActionTypes.FETCH_SCHEDULE_DAYS: {
      return adapter.updateOne(
        {
          id: action.payload.formId,
          changes: {
            loadingScheduleDays: true,
          },
        },
        state,
      );
    }
    case fromDCOScheduleActions.ActionTypes.FETCH_SCHEDULE_DAYS_ERROR: {
      return adapter.updateOne(
        {
          id: action.payload.formId,
          changes: {
            loadingScheduleDays: false,
            scheduleDaysError: action.payload.error,
          },
        },
        state,
      );
    }
    case ActionTypes.SAVE_FORM_SNAPSHOT: {
      return adapter.updateOne(
        {
          id: action.payload.formId,
          changes: {
            formSnapshot: action.payload.formSnapshot,
          },
        },
        state,
      );
    }
    case ActionTypes.RESET_SLOT: {
      return adapter.updateOne(
        {
          id: action.payload.formId,
          changes: {
            fullVisibilityEnabled: false,
            loading: undefined,
            response: undefined,
            error: undefined,
            requestDatetimeIsAvailable: undefined,
            formSnapshot: undefined,
            isWaitingList: undefined,
            selectedDatetimeSlot: undefined,
            timeSlots: undefined,
            loadingScheduleDays: undefined,
            scheduleDaysError: undefined,
          },
        },
        state,
      );
    }
    case ActionTypes.DUMMY_FETCH_SLOTS_SUCCESS: {
      return adapter.updateOne(
        {
          id: action.payload.formId,
          changes: {
            formSnapshot: action.payload.formSnapshot,
            loading: false,
            response: { slots: [] },
            error: null,
          },
        },
        state,
      );
    }
    case ActionTypes.DELETE_DATA:
    case RESET_BUILDER: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
